var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.15 4.03999C19.9175 3.99255 19.7504 3.78825 19.75 3.55099V2C19.75 0.895432 18.8546 0 17.75 0H5.25C3.59314 0 2.25 1.34314 2.25 3V21C2.25 22.6569 3.59314 24 5.25 24H19.75C20.8546 24 21.75 23.1046 21.75 22V6C21.7502 5.04947 21.0813 4.2301 20.15 4.03999ZM17.5 15.5C17.5 16.8807 16.3807 18 15 18C13.6193 18 12.5 16.8807 12.5 15.5C12.5 14.1193 13.6193 13 15 13C15.1391 12.9999 15.2779 13.0117 15.415 13.035C15.5604 13.0601 15.7094 13.0197 15.8222 12.9246C15.935 12.8296 16.0001 12.6895 16 12.542V10C16.0001 9.92456 15.9659 9.85316 15.907 9.806C15.849 9.75748 15.7716 9.73897 15.698 9.75601L10.698 10.827C10.5822 10.851 10.4988 10.9527 10.498 11.071V17.5C10.498 18.5114 9.88867 19.4231 8.95425 19.8099C8.01981 20.1967 6.94437 19.9825 6.22952 19.2671C5.51468 18.5517 5.3013 17.476 5.68887 16.5419C6.07645 15.6078 6.98865 14.9992 8 15C8.13907 14.9999 8.27789 15.0117 8.41501 15.035C8.56036 15.0601 8.70941 15.0197 8.8222 14.9246C8.935 14.8296 9.00009 14.6895 9 14.542V11.071C9.00381 10.2473 9.5784 9.53644 10.383 9.36L15.383 8.289C15.8998 8.17816 16.439 8.30682 16.85 8.63904C17.2611 8.97127 17.5 9.47148 17.5 10V15.5ZM17.5 4C17.6381 4 17.75 3.88808 17.75 3.75V2.25C17.75 2.11192 17.6381 2 17.5 2H5.25C4.69772 2 4.25 2.44771 4.25 3C4.25 3.55229 4.69772 4 5.25 4H17.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookMusic);
export default __webpack_public_path__ + "static/media/bookMusic.c84566d1.svg";
export { ForwardRef as ReactComponent };